<template>
  <div class="live-bid-block">
    <Teleport :disabled="!isScreenL" to=".mobile-place-bid-wrapper .mobile-place-bid-block" defer>
      <time-line></time-line>
      <place-bid @changeTab="changeTab($event)" :is-mobile-block="isScreenL"></place-bid>
    </Teleport>
  </div>
</template>

<script setup lang="ts">
  import PlaceBid from "@/components/_partials/PlaceBid.vue";
  import TimeLine from "@/components/_partials/TimeLine.vue";
  import { isScreenL } from "@/utils/media-size";

  const emit = defineEmits(["changeTab"]);

  const changeTab = () => {
    emit("changeTab", "lock");
  };
</script>
